<template>
    <rkm-content>
        <rkm-content-header :title="$route.meta.title">
            <template
                v-if="authorize('cadastro-waba-store')"
                v-slot:actions
            >
                <rkm-button
                    :to="{name: 'cadastro-waba-create'}"
                    color="primary"
                >
                    Cadastrar número
                </rkm-button>
            </template>
        </rkm-content-header>

        <rkm-content-body>
            <rkm-container>
                <List />
            </rkm-container>
        </rkm-content-body>
    </rkm-content>
</template>

<script>
// Components.
import List from '@/components/cadastro/waba/List'

// Mixins.
import {authorization} from '@/mixins'

export default {
    components: {List},
    mixins: [authorization],
}
</script>
